module.exports = __webpack_public_path__ + "img/post5.59aa18b9.png";